import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  API_LANG_MODE,
  DEFAULT_LANGUAGE,
  LANG_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
} from "./i18n/constants";
import azCommon from "./locales/az/common.json";
import ruCommon from "./locales/ru/common.json";
import enCommon from "./locales/en/common.json";

/** Gələcək namespace-lər buraya əlavə olunacaq */
export const NAMESPACES = ["common"];

const resources = {
  az: { common: azCommon },
  ru: { common: ruCommon },
  en: { common: enCommon },
};

const getSavedLanguage = () => {
  const saved = localStorage.getItem(LANG_STORAGE_KEY);
  if (SUPPORTED_LANGUAGES.includes(saved)) return saved;
  return DEFAULT_LANGUAGE;
};

const applyDocumentLanguage = (lng) => {
  document.documentElement.lang = lng;
};

i18n.use(initReactI18next).init({
  resources,
  lng: getSavedLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  defaultNS: "common",
  ns: NAMESPACES,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

applyDocumentLanguage(i18n.language);

i18n.on("languageChanged", (lng) => {
  localStorage.setItem(LANG_STORAGE_KEY, lng);
  applyDocumentLanguage(lng);
});

export { API_LANG_MODE, LANG_STORAGE_KEY, SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE };
export default i18n;
